import loadingSvg from './blankslate-loading-icon.svg'
import infoSvg from './blankslate-info-icon.svg'
import emailSvg from './email-success.svg'

export function getErrorPageContents(errorCode, errorDescription) {

  let title = "There's a problem with the system."
  let subtitle1 = 'SIGNIN ERROR'
  let subtitle2 = 'There could be a misconfiguration in the system or a service outage. We track these errors automatically, but if the problem persists feel free to contact us. Please try again.'
  let imgSrc = infoSvg

  if (errorCode === '503') {
    title = "The page couldn't be displayed because the internet connection was interrupted."
    subtitle1 = '503 ERROR'
    subtitle2 = 'Check your Wi-Fi or local network status and refresh the page.'
    imgSrc = loadingSvg
  }
  if (errorCode === '404') {
    title = "The page you're looking for could not be found."
    subtitle1 = '404 ERROR'
    subtitle2 = 'Check the address and try again. Or navigate to the page from the CJ homepage.'
    imgSrc = loadingSvg
  }
  if (errorCode === '500') {
    title = "There's a problem loading the page."
    subtitle1 = '500 ERROR'
    subtitle2 = "There's a technical problem that has prevented the page from loading. Try reloading the page or going to another page."
    imgSrc = infoSvg
  }
  if (errorCode === '403') {
    title = 'Unauthorized access'
    subtitle1 = '403 ERROR'
    subtitle2 = "You don't have permission to access this page. Try reaching out to the admin or going to another page."
    imgSrc = infoSvg
  }
  if (
    errorCode === 'This user has not been registered yet.' ||
    errorDescription === 'This user has not been registered yet.'
  ) {
    title = "There's a problem accessing this account."
    subtitle1 = 'USER LOGIN ERROR'
    subtitle2 = "There's a problem that has prevented access to this account. Please try again later. If the issue persists, please contact your account administrator or reach out to your CJ Account Team for assistance. You can also get support at cj.com."
    imgSrc = infoSvg
  }
  if ( errorCode === "access_denied" && errorDescription === "unverified_email" ) {
    title = "Email verification required"
    subtitle1 = 'PENDING EMAIL VERIFICATION'
    subtitle2 = "Please check your email and complete email verification before signing in."
    imgSrc = emailSvg
  }

  // auth 0 errors
  if ( errorCode === 'login_failed' ) {
    title = "There is a problem accessing this account."
    subtitle1 = 'USER LOGIN ERROR'
    subtitle2 = "There's a problem preventing access to this account. Please try again later. If the issue persists, please contact your account administrator or reach out to your CJ Account Team for assistance. You can also get support at cj.com."
    imgSrc = infoSvg
  }

  // alias codes grouped by functional areas (Auth0 custom DB script errors)
  if ( ['change_password_failed', 'change_password_error'].includes(errorCode) ) {
    title = "There is a problem updating your password for this account."
    subtitle1 = 'CHANGE PASSWORD ERROR'
    subtitle2 = "There's a problem that has prevented password updating for this account. Please try again later. If the issue persists, please contact your account administrator or reach out to your CJ Account Team for assistance. You can also get support at cj.com."
    imgSrc = infoSvg
  }

  if ( ['user_exists','create_user_failed','create_user_error'].includes(errorCode) ) {
    title = "There is a problem creating your user."
    subtitle1 = 'CREATE USER ERROR'
    subtitle2 = "There's a problem that has prevented your user from being created for this account. Please try again later. If the issue persists, please contact your account administrator or reach out to your CJ Account Team for assistance. You can also get support at cj.com."
    imgSrc = infoSvg
  }

  if ( ['delete_user_failed','delete_user_error'].includes(errorCode) ) {
    title = "There is a problem removing your account."
    subtitle1 = 'USER CLEANUP ERROR'
    subtitle2 = "There's a problem that has prevented cleaning up this account. Please try again later. If the issue persists, please contact your account administrator or reach out to your CJ Account Team for assistance. You can also get support at cj.com."
    imgSrc = infoSvg
  }

  if ( ['get_user_failed','get_user_error'].includes(errorCode) ) {
    title = "There is a problem retrieving your account."
    subtitle1 = 'GET USER ERROR'
    subtitle2 = "There's a problem that has prevented retrieving this account. Please try again later. If the issue persists, please contact your account administrator or reach out to your CJ Account Team for assistance. You can also get support at cj.com."
    imgSrc = infoSvg
  }

  if ( ['login_failed','login_error'].includes(errorCode) ) {
    title = "There is a problem accessing this account."
    subtitle1 = 'USER LOGIN ERROR'
    subtitle2 = "There's a problem that has prevented access to this account. Please try again later. If the issue persists, please contact your account administrator or reach out to your CJ Account Team for assistance. You can also get support at cj.com."
    imgSrc = infoSvg
  }

  if ( ['federated_user_login_failed','federated_user_login_error'].includes(errorCode) ) {
    title = "There is a problem accessing this account."
    subtitle1 = 'USER LOGIN ERROR'
    subtitle2 = "There's a problem that has prevented access to this account. Please try again later."
    imgSrc = infoSvg
  }

  if ( ['verify_user_failed','verify_user_error'].includes(errorCode) ) {
    title = "There is a problem verifying this account"
    subtitle1 = 'USER VERIFY ERROR'
    subtitle2 = "There's a problem verifying this account. Please try again later. If the issue persists, please contact your account administrator or reach out to your CJ Account Team for assistance. You can also get support at cj.com."
    imgSrc = infoSvg
  }

  // federated user invitation errors

  const federateUserInvitationTitle = "There is a problem processing your invitation"

  if ( errorCode === 'FEDERATED_USER_INVITATION_INVALID_TOKEN' ) {
    title =federateUserInvitationTitle
    subtitle1 = errorCode.replaceAll("_"," ")
    subtitle2 = "Invalid federated user invitation token. Please contact your support."
    imgSrc = infoSvg
  }

  if ( errorCode === 'FEDERATED_USER_INVITATION_ALREADY_PROCESSED' ) {
    title = federateUserInvitationTitle
    subtitle1 = errorCode.replaceAll("_"," ")
    subtitle2 = "This federated user invitation has already been completed."
    imgSrc = infoSvg
  }

  if ( errorCode === 'FEDERATED_USER_INVITATION_EXPIRED' ) {
    title = federateUserInvitationTitle
    subtitle1 = errorCode.replaceAll("_"," ")
    subtitle2 = "This federated user invitation has expired."
    imgSrc = infoSvg
  }

  if ( errorCode === 'FEDERATED_USER_INVITATION_SERVER_ERROR' ) {
    title = federateUserInvitationTitle
    subtitle1 = errorCode.replaceAll("_"," ")
    subtitle2 = "An unexpected error occurred while processing the federated user invitation. Please contact your support."
    imgSrc = infoSvg
  }

  if ( errorCode === 'FEDERATED_USER_INVITATION_UPDATE_FAILED' ) {
    title = federateUserInvitationTitle
    subtitle1 = errorCode.replaceAll("_"," ")
    subtitle2 = "An unexpected error occurred while processing the federated user invitation. Please contact your support."
    imgSrc = infoSvg
  }

  return { title, subtitle1, subtitle2, imgSrc }
}
